import $ from 'jquery';
import { track } from 'util/analytics';
import { showConfirmationModal } from 'util/ui';
import * as latexLoader from 'util/latex_loader';

/** @param $containers */
function updateLatex($containers) {
  $containers.each((i, container) => {
    const $container = $(container);
    latexLoader.loadForElement($container);
    $container.parent().find('.uses-latex, .latex').css('visibility', 'visible');
  });
}

/**
 * @controller
 * Direct users to an equation editor.
 * @param {JQuery} $trigger
 */
function equationEditorTrigger($trigger) {
  const trackAction = id => {
    track('ui', {
      action: 'click',
      element_type: id,
      element_id: 'link',
    });
  };

  $trigger.on('click', e => {
    const data = $trigger.data();

    trackAction(data.axClicked);

    if (!e.metaKey) {
      e.preventDefault();
      showConfirmationModal({
        text: $trigger.data('text'),
      }).then(confirmed => {
        if (confirmed) {
          trackAction(data.axConfirmed);
          window.open($trigger.attr('href'));
        }
      });
    }
  });
}

export { updateLatex, equationEditorTrigger };
